import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// ✅ Remove Avatar
export const removeAvatar = createAsyncThunk(
  "profile/removeAvatar",
  async ({ token, image_url }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/profile/remove-avatar`,
        {}, // No body data required
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          params: {
            image_url: image_url, // Correctly passing query params here
          },
        }
      );

      if (response.data.status) {
        toast.success(response.data.response);
        return response.data;
      } else {
        toast.error(response.data.message || "Failed to remove avatar!");
        return rejectWithValue(response.data);
      }
    } catch (error) {
    //   console.error("Error removing avatar:", error);
      
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// ✅ Add Avatar
export const addAvatar = createAsyncThunk(
  "profile/addAvatar",
  async ({ token, file }, { rejectWithValue }) => {
    try {
        // console.log("runnning")
      const formData = new FormData();
      formData.append("avatar", file);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/profile/avatar`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
      
        return response.data; // Return avatar URL or path
      } else {
        
        return rejectWithValue(response.data);
      }
    } catch (error) {
    //   console.error("Error uploading avatar:", error);
      toast.error(error);
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// ✅ Profile Slice
const profileSlice = createSlice({
  name: "profile",
  initialState: {
    isLoading: false,
    error: null,
    avatar: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 🎉 Remove Avatar Reducers
      .addCase(removeAvatar.pending, (state) => {
        state.isLoading = 'delete';
        state.error = null;
      })
      .addCase(removeAvatar.fulfilled, (state, action) => {
        state.isLoading = null;
        state.avatar = null; // Avatar removed successfully
        state.error = null;
      })
      .addCase(removeAvatar.rejected, (state, action) => {
        state.isLoading = null;
        state.error = action.payload || "Failed to remove avatar!";
      })

      // 🎉 Add Avatar Reducers
      .addCase(addAvatar.pending, (state) => {
        state.isLoading = 'update';
        state.error = null;
      })
      .addCase(addAvatar.fulfilled, (state, action) => {
        state.isLoading = null;
       
        state.error = null;
      })
      .addCase(addAvatar.rejected, (state, action) => {
        state.isLoading = null;
        state.error = action.payload || "Failed to upload avatar!";
      });
  },
});

export default profileSlice.reducer;
